module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.8-87.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.8.md
// module id = 504
// module chunks = 336